import { render, staticRenderFns } from "./ManageUserRoles.vue?vue&type=template&id=7165c68a&scoped=true&"
import script from "./ManageUserRoles.vue?vue&type=script&lang=js&"
export * from "./ManageUserRoles.vue?vue&type=script&lang=js&"
import style0 from "./ManageUserRoles.vue?vue&type=style&index=0&id=7165c68a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7165c68a",
  null
  
)

export default component.exports